import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

export default class SentryManager {
    static dsn =
        'https://9582ce1f81e59ab906d391d18e487097@o4505906598641664.ingest.sentry.io/4506154465689600'
    static options = {
        integrations: [new Integrations.BrowserTracing()],
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
    }
    static enable = () => {
        Sentry.init({
            dsn: this.dsn,
            environment: window.env,
            ...this.options,
        })
    }
    static disable = () => {
        Sentry.init({
            dsn: '',
            environment: window.env,
            ...this.options,
        })
    }
}
